import { call, put } from 'redux-saga/effects';
import { generateReportFailure, generateReportSuccess } from '../actions';
import { ApiError } from 'store/api/types';
import { LoadReportTotalsRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { LoadReportResponse, loadReportTotals } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { VatReportData } from '../models';
import { MessageType } from 'store/api/enums';
import { logoutRequest } from 'store/auth/actions';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* loadReportTotalsSaga(action: LoadReportTotalsRequestAction) {
  try {
    let err: ApiError | null;
    const { mappingId, dataLogId } = action.payload;

    const response: LoadReportResponse = yield call(
      loadReportTotals,
      mappingId,
      dataLogId
    );

    // Check if response exists
    if (!response) {
      throw new Error('No response received from loadReportTotals API');
    }

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    if (
      !response.data &&
      response.responseMessage?.messageType === MessageType.WARNING
    ) {
      const message: MessageData = {
        title: i18n.t('notifications.server-message-2'),
        description:
          response.responseMessage?.message || i18n.t('global.no-data-available'),
        type: MessageStates.WARNING,
      };
      yield put(turnMessageOn(message));
      yield put(generateReportFailure());
      yield put(push(routes.main));
    } else {
      const vatReportData: VatReportData = response.data;

      if (!vatReportData) {
        throw new Error('No report data received from API');
      }

      if (!vatReportData.journals) {
        vatReportData.journals = [];
      }

      if (!vatReportData.exceptions) {
        vatReportData.exceptions = [];
      }

      yield put(generateReportSuccess(vatReportData, true, true));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(generateReportFailure());
  }
}
